import api from 'modules/api/index';

export const getLongOperationRequest = (id) => {
  return api.get(`/long-operation/${id}`);
};
